import React from 'react';
import { Flex, Text, Button, Heading, Box, Card } from 'rebass';
import styled from 'styled-components';
import { Route, NavLink as NavLinkRouter, withRouter } from 'react-router-dom';
import 'react-vertical-timeline-component/style.min.css';
import moment from 'moment-timezone';
import { Mutation, Query, compose } from 'react-apollo';

import withSession from '../lib/withSession';
import gql from 'graphql-tag';
import PillsBottle from '../static/PillsBottle.png';
import PalomaRxDetails from './PalomaRxDetails';
import { Skeleton } from '../components/loadingSkeleton/Skeleton';
import { isPreviewMode } from '../utils/environments';
import Communicator from './myRx/Communicator';
import Estriol from '../static/your_Account.png';
import { GET_PALOMARX_PRODUCTS, GET_VISITS_TOKEN } from './PalomaRxProducts';
import { GET_ASYNCRX_APPOINTMENT_CONVERSATION } from '../graphql';

export const GET_RX_TOKEN = gql`
  mutation getRxToken {
    getRxToken
  }
`;

const ASYNC_VISITS = gql`
  query getPalomaAsyncVisits {
    getPalomaAsyncVisits {
      inProgress {
        status
        id
        sku
        product_label
        started_at
        updated_at
      }
      submitted {
        status
        id
        sku
        product_label
        submitted_at
        updated_at
        helpscout_conversation_id
        appointment_id
        encounter_id
        provider_id
      }
      sentToPharmacy {
        status
        id
        sku
        product_label
        submitted_at
        updated_at
        helpscout_conversation_id
        reapply_available_at
        appointment_id
        encounter_id
        provider_id
        prescription {
          medication_label
          pharmacy {
            name
            address
            city
            state
            zipcode
            phone
          }
          sent_at
        }
      }
      declined {
        status
        id
        sku
        product_label
        submitted_at
        updated_at
        helpscout_conversation_id
        reapply_available_at
        appointment_id
        encounter_id
        provider_id
      }
    }
  }
`;
export const GET_PALOMA_RX = gql`
  query getPalomaRxs {
    getPalomaRxs {
      id
      medication {
        name
        strength
        strengthUnit
        form
        quantity
        sig {
          raw
          aiParse {
            phases {
              unitsPerDay
              durationDays
            }
            steadyStateUnitsPerDay
            firstFillDaysSupply
            rawAiDaysSupply
            source
          }
          confidence
          parsed {
            unitsPerDose
            dosesPerDay
            frequencySchedule
            confidence
            reason
          }
          unitsPerDay
        }
        ndc
        sku
        frequency
        productMetadata {
          imageUrl
          productInformation
          activeIngredients
          inactiveIngredients
          importantSafetyInformation
          medicationGuideUrl
          indications
          directions
          commonSideEffects
          warnings
          storage
          manufacturer
        }
      }
      prescriber
      status
      isLdn
      refillsRemaining
      refillsAllowed
      writtenDate
      expirationDate
      estimatedDaysSupply
      athenaEncounterId
      athenaAppointmentId
      createdAt
      fills {
        id
        fillNumber
        fillDate
        quantity
        daysSupply
        dates {
          runOutDate
          eligibleRefillDate
          shipByDate
          notificationDate
          autoChargeDate
          careTeamNotificationDate
          anchor
          anchorDate
        }
        payment {
          amount
          status
          paidAt
        }
        shipping {
          trackingNumber
          trackingUrl
          carrier
          estimatedDelivery
          shippedAt
          deliveredAt
          latestStatus
        }
        autoCharged
        autoChargeStatus
        attestation {
          status
          severity
          notificationAttempts
          lastNotifiedAt
          attestationId
          submission {
            version
            answers {
              noOpioids
              noContraindications
              tolerating
            }
            passed
            severity
            flaggedQuestions
            supersedes
            submittedAt
          }
        }
        createdAt
      }
      orders {
        id
        status
        honeybeeOrderId
        honeybeeOrderNumber
        fulfillmentMode
        pricing {
          medicationCost
          dispensingFee
          shippingFee
          serviceFee
          total
        }
        payment {
          amount
          status
          paidAt
        }
        tracking {
          carrier
          trackingNumber
          estimatedDelivery
          shippedAt
          deliveredAt
        }
        exception {
          name
          message
        }
        createdAt
        updatedAt
      }
    }
  }
`;
const DetailNavigation = styled.div`
  @media screen and (min-width: 68.8125em) {
    display: none;
    margin-bottom: 0px;
    margin-left: 0;
    margin-top: 0;
  }
`;

const BackButton = styled.div`
  background: rgba(180, 205, 244, 0.5);
  width: 100%;
  color: #333;
  padding: 6px 12px;

  @media screen and (min-width: 68.8125em) {
    display: none;
  }
`;

const BackButtonDesktop = styled.div`
  @media screen and (max-width: 52em) {
    display: none;
  }
`;

const DetailContainer = styled(Flex)`
  display: none;
  overflow-y: auto;
  &.selected {
    right: 0;
    top: 0;
    position: fixed;
    height: 100vh;
    z-index: 1000;
    width: 100vw;
    max-width: 100vw;
    display: flex;
    justify-content: flex-end;
    background: transparent;
    backdrop-filter: blur(2px);
  }

  @media screen and (min-width: 52em) {
    display: none;
  }
`;

const Inner = styled(Flex)`
  max-width: 750px;
  height: 100vh;
  background: #fdfbfc;
  overflow-y: auto;
  box-shadow: 5px 5px 30px 0px rgba(78, 101, 138, 0.35);
  @media screen and (min-width: 52em) {
    padding: 24px;
  }
  @media screen and (max-width: 52em) {
    max-width: calc(100vw);
    width: 100vw;
  }
`;

const NavLink = styled(NavLinkRouter)`
  text-decoration: none;
  color: #355078;
  display: flex;
  align-items: center;
  width: 100%;
  transition: all 300ms ease;
  &.active {
    background: transparent;
  }
  &:hover {
    background: transparent;
  }
`;
const NavLinkSub = styled(NavLinkRouter)`
  text-decoration: none;
  color: #355078;
  display: flex;
  align-items: center;
  transition: all 300ms ease;
  &.active {
    background: transparent;
  }
  &:hover {
    background: transparent;
  }
`;

const Container = styled(Box)`
  max-width: 1024px;
  width: 100%;
  margin: 0 auto;
  padding-top: 40px;
  @media screen and (max-width: 52em) {
    padding-left: 8px;
    padding-right: 8px;
  }
`;

const InnerContainer = styled(Flex)`
  max-width: 800px;
  margin: 0 auto;
  flex-direction: column;
  padding-bottom: 60px;
  @media screen and (max-width: 1100px) {
    max-width: calc(100vw - 300px);
  }
  @media screen and (max-width: 830px) {
    max-width: calc(100vw - 80px);
  }
`;

const Img = styled.img`
  display: initial;
  width: 220px;
  @media screen and (max-width: 52em) {
    width: 100%;
  }
`;
const FlexCard = styled(Flex)`
  flex-direction: row;
  @media screen and (max-width: 52em) {
    flex-direction: column;
  }
`;

function toTitleCase(str) {
  return str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

const StatusBadge = ({ prescription }) => {
  if (!prescription || !prescription.status) return null;

  switch (prescription.status.toLowerCase()) {
    case 'active':
      return (
        <Card p={'3px 12px'} style={{ background: '#CFEEDE', maxWidth: 'fit-content', borderRadius: 20, position: 'absolute', top: 8, right: 8 }}>
          <Text fontSize={14} fontWeight={300} color={'#034630'}>
            Active
          </Text>
        </Card>
      );
    case 'cancelled':
      return (
        <Card p={'3px 12px'} style={{ background: '#e6e6e6', maxWidth: 'fit-content', borderRadius: 20, position: 'absolute', top: 8, right: 8 }}>
          <Text fontSize={14} fontWeight={300} color={'#4a4a4a'}>
            {prescription.status}
          </Text>
        </Card>
      );
    case 'paid':
      return (
        <Card p={'3px 12px'} style={{ background: '#D8E7F7', maxWidth: 'fit-content', borderRadius: 20, position: 'absolute', top: 8, right: 8 }}>
          <Text fontSize={14} fontWeight={300} color={'#2F4772'}>
            Paid
          </Text>
        </Card>
      );
    default:
      return (
        <Card p={'3px 12px'} style={{ background: '#f3e8d7', maxWidth: 'fit-content', borderRadius: 20, position: 'absolute', top: 8, right: 8 }}>
          <Text fontSize={14} fontWeight={300} color={'#553b16'}>
            {prescription.status.replace('_', ' ')}
          </Text>
        </Card>
      );
  }
};

const PrescriptionDisplaySkeleton = () => {
  return (
    <Box
      style={{
        borderRadius: '10px 10px 40px 40px',
        backgroundColor: '#E7F0FF',
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
      }}
    >
      <FlexCard
        style={{
          width: '100%',
          background: 'white',
          padding: '8px',
          borderRadius: '10px',
          gap: 32,
          boxShadow: '5px 10px 50px 0 rgba(0, 0, 0, 0.07)',
          cursor: 'pointer',
        }}
        alignItems={'center'}
      >
        <Img src={PillsBottle} style={{ objectFit: 'cover', borderRadius: 12 }} height="220" alt="" />
        <Flex flex={1} flexDirection={'column'} justifyContent={'center'} style={{ padding: '16px 0 0 0' }}>
          <Skeleton width="200px" height="22px" />
          <ul>
            <li>
              <Skeleton width="200px" height="16px" />
            </li>
            <li>
              <Skeleton width="150px" height="16px" />
            </li>
            <li>
              <Skeleton width="180px" height="16px" />
            </li>
          </ul>

          <Flex style={{ padding: '16px 0px', gap: 20 }} justifyContent={'space-between'} alignItems={'center'}>
            <Skeleton width="250px" height="24px" />
            <Skeleton width="150px" height="24px" />
          </Flex>
        </Flex>
      </FlexCard>
    </Box>
  );
};

const PrescriptionDisplay = ({ prescription }) => {
  const x = prescription;
  const medication = x.medication;

  return (
    <Box
      style={{
        borderRadius: '10px 10px 40px 40px',
        backgroundColor: '#E7F0FF',
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
      }}
    >
      <NavLink to={`/my-rx/${x.id}`}>
        <FlexCard
          style={{
            width: '100%',
            background: 'white',
            padding: '8px',
            borderRadius: '10px',
            gap: 32,
            boxShadow: '5px 10px 50px 0 rgba(0, 0, 0, 0.07)',
            cursor: 'pointer',
            position: 'relative',
          }}
        >
          <Img src={(medication.productMetadata || {}).imageUrl || PillsBottle} style={{ objectFit: 'cover', borderRadius: 12, height: 'stretch' }} alt="" />
          <Flex
            flex={1}
            style={{
              width: '100%',
            }}
            alignItems={'center'}
          >
            <Flex flex={1} flexDirection={'column'} justifyContent={'center'} style={{ padding: '16px 0 0 0' }}>
              <Text style={{ fontSize: 16, fontWeight: 600 }}>{x.medication.name}</Text>

              <Flex style={{ gap: 8, opacity: 0.8 }} mt={'16px'} mb={'6px'} alignItems={'center'}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M19.5 3.75H4.5C3.25736 3.75 2.25 4.75736 2.25 6V19.5C2.25 20.7426 3.25736 21.75 4.5 21.75H19.5C20.7426 21.75 21.75 20.7426 21.75 19.5V6C21.75 4.75736 20.7426 3.75 19.5 3.75Z"
                    stroke="#344F7A"
                    strokeLinejoin="round"
                  />
                  <path d="M13.875 12C14.4963 12 15 11.4963 15 10.875C15 10.2537 14.4963 9.75 13.875 9.75C13.2537 9.75 12.75 10.2537 12.75 10.875C12.75 11.4963 13.2537 12 13.875 12Z" fill="#344F7A" />
                  <path
                    d="M17.625 12C18.2463 12 18.75 11.4963 18.75 10.875C18.75 10.2537 18.2463 9.75 17.625 9.75C17.0037 9.75 16.5 10.2537 16.5 10.875C16.5 11.4963 17.0037 12 17.625 12Z"
                    fill="#344F7A"
                  />
                  <path
                    d="M13.875 15.75C14.4963 15.75 15 15.2463 15 14.625C15 14.0037 14.4963 13.5 13.875 13.5C13.2537 13.5 12.75 14.0037 12.75 14.625C12.75 15.2463 13.2537 15.75 13.875 15.75Z"
                    fill="#344F7A"
                  />
                  <path
                    d="M17.625 15.75C18.2463 15.75 18.75 15.2463 18.75 14.625C18.75 14.0037 18.2463 13.5 17.625 13.5C17.0037 13.5 16.5 14.0037 16.5 14.625C16.5 15.2463 17.0037 15.75 17.625 15.75Z"
                    fill="#344F7A"
                  />
                  <path
                    d="M6.375 15.75C6.99632 15.75 7.5 15.2463 7.5 14.625C7.5 14.0037 6.99632 13.5 6.375 13.5C5.75368 13.5 5.25 14.0037 5.25 14.625C5.25 15.2463 5.75368 15.75 6.375 15.75Z"
                    fill="#344F7A"
                  />
                  <path
                    d="M10.125 15.75C10.7463 15.75 11.25 15.2463 11.25 14.625C11.25 14.0037 10.7463 13.5 10.125 13.5C9.50368 13.5 9 14.0037 9 14.625C9 15.2463 9.50368 15.75 10.125 15.75Z"
                    fill="#344F7A"
                  />
                  <path
                    d="M6.375 19.5C6.99632 19.5 7.5 18.9963 7.5 18.375C7.5 17.7537 6.99632 17.25 6.375 17.25C5.75368 17.25 5.25 17.7537 5.25 18.375C5.25 18.9963 5.75368 19.5 6.375 19.5Z"
                    fill="#344F7A"
                  />
                  <path
                    d="M10.125 19.5C10.7463 19.5 11.25 18.9963 11.25 18.375C11.25 17.7537 10.7463 17.25 10.125 17.25C9.50368 17.25 9 17.7537 9 18.375C9 18.9963 9.50368 19.5 10.125 19.5Z"
                    fill="#344F7A"
                  />
                  <path
                    d="M13.875 19.5C14.4963 19.5 15 18.9963 15 18.375C15 17.7537 14.4963 17.25 13.875 17.25C13.2537 17.25 12.75 17.7537 12.75 18.375C12.75 18.9963 13.2537 19.5 13.875 19.5Z"
                    fill="#344F7A"
                  />
                  <path d="M6 2.25V3.75M18 2.25V3.75" stroke="#344F7A" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M21.75 7.5H2.25" stroke="#344F7A" strokeLinejoin="round" />
                </svg>
                <Text fontSize={'13px'}>
                  <span style={{ fontWeight: 300 }}>Prescribed on:</span> {moment(x.writtenDate).format('MM/DD/YYYY')}
                </Text>
              </Flex>

              <Flex style={{ gap: 8, opacity: 0.8 }} mb={'6px'} alignItems={'center'}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 5C14 7.7615 11.7615 10 9 10C6.2385 10 4 7.7615 4 5C4 2.2385 6.2385 0 9 0C11.7615 0 14 2.2385 14 5ZM13 5C13 6.06087 12.5786 7.07828 11.8284 7.82843C11.0783 8.57857 10.0609 9 9 9C7.93913 9 6.92172 8.57857 6.17157 7.82843C5.42143 7.07828 5 6.06087 5 5C5 3.93913 5.42143 2.92172 6.17157 2.17157C6.92172 1.42143 7.93913 1 9 1C10.0609 1 11.0783 1.42143 11.8284 2.17157C12.5786 2.92172 13 3.93913 13 5ZM5.957 11.4275L5.9625 11.4385L6 11.512H11.8745C11.989 11.295 12.2485 10.949 12.5 11.0065C13.065 11.135 13.634 11.314 14.1805 11.5345L14.197 11.5265L14.2025 11.5375L14.2065 11.545C16.264 12.381 18 13.798 18 15.285V18H0V15.285C0 13.3975 2.798 11.6215 5.5 11.0065C5.7205 10.9565 5.8515 11.2165 5.957 11.4275ZM13.352 12.2915C13.1375 12.2163 12.9206 12.1484 12.7015 12.088L12.4785 12.512H5.3965L5.1895 12.1185L5.0095 12.1725C5.00583 12.2052 5.00317 12.2425 5.0015 12.2845C4.995 12.457 5.008 12.6615 5.0365 12.8695C5.06556 13.0865 5.11239 13.3007 5.1765 13.51C5.52773 13.5516 5.85296 13.716 6.09476 13.9741C6.33655 14.2323 6.47935 14.5675 6.49795 14.9207C6.51654 15.2739 6.40972 15.6223 6.19636 15.9044C5.983 16.1865 5.67683 16.3842 5.3319 16.4624C4.98698 16.5407 4.6255 16.4945 4.31129 16.3321C3.99709 16.1697 3.75038 15.9015 3.61473 15.5749C3.47908 15.2482 3.46321 14.8842 3.56994 14.547C3.67666 14.2098 3.89911 13.9211 4.198 13.732L4.194 13.718C4.12723 13.4843 4.0776 13.246 4.0455 13.005C4.0243 12.8511 4.01028 12.6962 4.0035 12.541C3.3855 12.805 2.809 13.124 2.326 13.476C1.365 14.178 1 14.834 1 15.285V17H17V15.285C17 14.8335 16.635 14.1775 15.674 13.4765C15.2549 13.1753 14.8086 12.9138 14.341 12.6955C14.3205 12.9665 14.2791 13.2354 14.217 13.5H14.5C14.5928 13.5 14.6838 13.5259 14.7628 13.5748C14.8417 13.6236 14.9055 13.6935 14.947 13.7765L15.447 14.7765C15.482 14.846 15.5 14.9225 15.5 15V16C15.5 16.1326 15.4473 16.2598 15.3536 16.3536C15.2598 16.4473 15.1326 16.5 15 16.5H14V15.5H14.5V15.118L14.191 14.5H12.809L12.5 15.118V15.5H13V16.5H12C11.8674 16.5 11.7402 16.4473 11.6464 16.3536C11.5527 16.2598 11.5 16.1326 11.5 16V15C11.5 14.9225 11.518 14.846 11.553 14.7765L12.053 13.7765C12.0945 13.6935 12.1583 13.6236 12.2372 13.5748C12.3162 13.5259 12.4072 13.5 12.5 13.5H13.181L13.1995 13.438C13.2465 13.2775 13.2885 13.078 13.317 12.87C13.345 12.664 13.358 12.4625 13.352 12.2915ZM5.5 15C5.5 15.287 5.269 15.5075 5 15.5075C4.731 15.5075 4.5 15.2875 4.5 15C4.5 14.713 4.731 14.4925 5 14.4925C5.269 14.4925 5.5 14.7125 5.5 15Z"
                    fill="#344F7A"
                  />
                </svg>

                <Text fontSize={'13px'}>
                  <span style={{ fontWeight: 300 }}>Provider:</span> {x.prescriber}
                </Text>
              </Flex>

              <Flex style={{ gap: 8, opacity: 0.8 }} alignItems={'center'}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M0 9H2V12C4.5 14 4.5 15.731 4.5 18.472V21.5C4.5 22.0304 4.28929 22.5391 3.91421 22.9142C3.53914 23.2893 3.03043 23.5 2.5 23.5H0M24 9H22V12C19.5 14 19.5 15.731 19.5 18.472V21.5C19.5 22.0304 19.7107 22.5391 20.0858 22.9142C20.4609 23.2893 20.9696 23.5 21.5 23.5H24M7.5 18.472V21.5C7.5 22.0304 7.71071 22.5391 8.08579 22.9142C8.46086 23.2893 8.96957 23.5 9.5 23.5H14.5C15.0304 23.5 15.5391 23.2893 15.9142 22.9142C16.2893 22.5391 16.5 22.0304 16.5 21.5V18.472C16.5 15.732 16.5 14 14 12V9H10V12C7.5 14 7.5 15.731 7.5 18.472ZM14 4.446C14 5.566 13.105 6.5 12 6.5C10.895 6.5 10 5.566 10 4.446C10.0013 4.33667 10.0173 4.22467 10.048 4.11C10.238 3.379 10.745 2.784 11.214 2.2L11.334 2.052C11.993 1.119 12 0.342 12 0C12 0.342 12.007 1.12 12.667 2.052L12.787 2.2C13.255 2.784 13.762 3.379 13.952 4.11C13.9833 4.22467 13.9993 4.33667 14 4.446Z"
                    stroke="#344F7A"
                  />
                </svg>

                <Text fontSize={'13px'}>
                  <span style={{ fontWeight: 300 }}>Refills remaining:</span> {x.refillsRemaining || 0}
                </Text>
              </Flex>
              <Flex style={{ padding: '16px 0px', gap: 20 }} justifyContent={'space-between'} alignItems={'center'}>
                {medication.productMetadata &&
                  medication.productMetadata.medicationGuideUrl && (
                    <Text
                      style={{ fontWeight: 300, fontSize: '14px', textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        window.open(medication.productMetadata.medicationGuideUrl, '_blank');
                      }}
                    >
                      Review the medication guide {' >'}
                    </Text>
                  )}
              </Flex>
              <LatestFromPhysician visit={null} appointmentId={x.athenaAppointmentId} style={{ marginBottom: '16px' }} />
            </Flex>
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none" style={{ marginRight: '12px' }}>
              <path
                d="M0.365983 0.365983C0.131644 0.600393 0 0.918278 0 1.24973C0 1.58119 0.131644 1.89907 0.365983 2.13348L6.55348 8.32098L0.365983 14.5085C0.138286 14.7442 0.0122922 15.06 0.0151402 15.3877C0.0179882 15.7155 0.14945 16.029 0.38121 16.2608C0.61297 16.4925 0.926485 16.624 1.25423 16.6268C1.58198 16.6297 1.89773 16.5037 2.13348 16.276L9.20473 9.20473C9.43907 8.97032 9.57072 8.65244 9.57072 8.32098C9.57072 7.98953 9.43907 7.67164 9.20473 7.43723L2.13348 0.365983C1.89907 0.131644 1.58119 0 1.24973 0C0.918278 0 0.600393 0.131644 0.365983 0.365983Z"
                fill="#344F7A"
              />
            </svg>

            <StatusBadge prescription={x} />
          </Flex>
        </FlexCard>
      </NavLink>
    </Box>
  );
};

const LoadingScreen = () => {
  return (
    <Container>
      <InnerContainer>
        <Heading mb={4}>My Rx</Heading>
        <Text mb={3}>View your prescriptions, refill status, and pharmacy details.</Text>

        <Flex flex={1} justifyContent="center" alignItems="center" flexDirection={'column'} style={{ opacity: 0.7, gap: 32 }}>
          {[1, 2, 3, 4, 5, 6, 7].map((x) => (
            <PrescriptionDisplaySkeleton key={x} />
          ))}
        </Flex>
      </InnerContainer>
    </Container>
  );
};

export const LatestFromPhysician = ({ visit, buttonCaption, appointmentId, style }) => {
  let _appointmentId = (visit || {}).appointment_id || appointmentId; // || (!!isPreviewMode ? 96157 : null);
  if (!_appointmentId) return null;

  return (
    <Flex flexDirection={'column'} style={{ borderTop: '1px solid #eceef4', paddingTop: '8px', ...style }} mt={'8px'}>
      <Query query={GET_ASYNCRX_APPOINTMENT_CONVERSATION} variables={{ appointmentId: _appointmentId.toString(), isAsync: true }} notifyOnNetworkStatusChange={true} fetchPolicy="cache-and-network">
        {({ loading, error, data }) => {
          if (loading && (!data || !data.getAsyncRxConversation)) {
            return null;
          }
          if (error) {
            return null;
          }
          if (data && data.getAsyncRxConversation && data.getAsyncRxConversation.length > 0 && data.getAsyncRxConversation[0].preview) {
            return (
              <>
                <Text style={{ fontSize: '12px', fontWeight: 500, opacity: 0.8 }}>LATEST FROM YOUR PHYSICIAN</Text>
                <NavLinkSub to={{ pathname: `/my-rx/communicator/${_appointmentId.toString()}`, state: { isAsync: true } }}>
                  <Flex flex={1} style={{ backgroundColor: '#eff3f7', padding: '6px 12px', borderRadius: '8px' }} mb={'8px'} mt={'4px'}>
                    <Text
                      flex={1}
                      mr={3}
                      style={{
                        fontSize: '13px',
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        overflow: 'hidden',
                      }}
                    >
                      {data.getAsyncRxConversation[0].preview}
                    </Text>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 10 17" fill="none" style={{ alignSelf: 'center' }}>
                      <path
                        d="M0.365983 0.365983C0.131644 0.600393 0 0.918278 0 1.24973C0 1.58119 0.131644 1.89907 0.365983 2.13348L6.55348 8.32098L0.365983 14.5085C0.138286 14.7442 0.0122922 15.06 0.0151402 15.3877C0.0179882 15.7155 0.14945 16.029 0.38121 16.2608C0.61297 16.4925 0.926485 16.624 1.25423 16.6268C1.58198 16.6297 1.89773 16.5037 2.13348 16.276L9.20473 9.20473C9.43907 8.97032 9.57072 8.65244 9.57072 8.32098C9.57072 7.98953 9.43907 7.67164 9.20473 7.43723L2.13348 0.365983C1.89907 0.131644 1.58119 0 1.24973 0C0.918278 0 0.600393 0.131644 0.365983 0.365983Z"
                        fill="#344F7A"
                      />
                    </svg>
                  </Flex>
                </NavLinkSub>
              </>
            );
          }

          return null;
        }}
      </Query>
      <NavLinkSub style={{ alignSelf: 'flex-end' }} to={{ pathname: `/my-rx/communicator/${_appointmentId.toString()}`, state: { isAsync: true } }}>
        <Button variant={'outline'} style={{ maxWidth: 'fit-content', fontSize: '14px', fontWeight: 400, paddingLeft: '16px', paddingRight: '16px', paddingTop: '8px', paddingBottom: '8px' }}>
          {buttonCaption || 'Message clinician'}
        </Button>
      </NavLinkSub>
    </Flex>
  );
};

const AsyncVisitsInProgress = ({ visit, products }) => {
  const product = products.find((x) => x.palomaSku === visit.sku.replace('_', '-').toUpperCase());

  return (
    <Box
      style={{
        borderRadius: '10px 10px 40px 40px',
        backgroundColor: '#E7F0FF',
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
      }}
    >
      <FlexCard
        style={{
          width: '100%',
          background: 'white',
          padding: '8px',
          borderRadius: '10px',
          gap: 32,
          boxShadow: '5px 10px 50px 0 rgba(0, 0, 0, 0.07)',
          position: 'relative',
        }}
      >
        <Img src={(product || {}).imageUrl || PillsBottle} style={{ objectFit: 'cover', borderRadius: 12, height: 'stretch' }} alt="" />
        <Flex flex={1} alignItems={'flex-start'}>
          <Flex flex={1} flexDirection={'column'} justifyContent={'center'} style={{ padding: '16px 0 ' }}>
            <Text style={{ fontSize: 16, fontWeight: 600 }}>{visit.product_label}</Text>
            <Card
              mt={3}
              mb={3}
              p={'3px 12px'}
              style={{
                background: '#f7dad8',
                maxWidth: 'fit-content',
                borderRadius: 20,
              }}
            >
              <Text fontSize={14} fontWeight={500} color={'#723b2f'}>
                Intake Incomplete
              </Text>
            </Card>
            <Flex style={{ gap: 8, opacity: 0.8 }} mb={'6px'} alignItems={'center'}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM12 6C12.2449 6.00003 12.4813 6.08996 12.6644 6.25272C12.8474 6.41547 12.9643 6.63975 12.993 6.883L13 7V11.586L15.707 14.293C15.8863 14.473 15.9905 14.7144 15.9982 14.9684C16.006 15.2223 15.9168 15.4697 15.7488 15.6603C15.5807 15.8508 15.3464 15.9703 15.0935 15.9944C14.8406 16.0185 14.588 15.9454 14.387 15.79L14.293 15.707L11.293 12.707C11.1376 12.5514 11.0378 12.349 11.009 12.131L11 12V7C11 6.73478 11.1054 6.48043 11.2929 6.29289C11.4804 6.10536 11.7348 6 12 6Z"
                  fill="#344F7A"
                />
              </svg>

              <Text fontSize={'13px'}>
                Started on{' '}
                {moment(visit.started_at)
                  .tz(moment.tz.guess())
                  .format('MMM D, YYYY [at] h:mm A z')}
              </Text>
            </Flex>
            <Flex style={{ gap: 8, opacity: 0.8 }} alignItems={'center'}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M18.024 7.04299C16.8528 5.87629 15.3626 5.08233 13.741 4.76114C12.1194 4.43996 10.439 4.60592 8.91151 5.23811C7.38406 5.87031 6.0779 6.94045 5.1576 8.31371C4.23731 9.68696 3.74405 11.3019 3.73999 12.955"
                  stroke="#344F7A"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                />
                <path
                  d="M17.3501 2.75L18.1821 6.122C18.2204 6.26895 18.2285 6.42214 18.2059 6.57231C18.1833 6.72248 18.1305 6.86652 18.0507 6.9957C17.9709 7.12488 17.8657 7.23654 17.7415 7.3239C17.6173 7.41127 17.4766 7.47254 17.3281 7.504L13.9561 8.347"
                  stroke="#344F7A"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5.97607 16.957C7.14717 18.1241 8.63753 18.9183 10.2593 19.2397C11.8811 19.5611 13.5617 19.3952 15.0894 18.763C16.617 18.1308 17.9233 17.0605 18.8437 15.687C19.764 14.3135 20.2572 12.6984 20.2611 11.045"
                  stroke="#344F7A"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                />
                <path
                  d="M6.65004 21.25L5.81804 17.878C5.77988 17.7309 5.77191 17.5777 5.79461 17.4275C5.81731 17.2774 5.87021 17.1334 5.95012 17.0042C6.03003 16.875 6.13529 16.7634 6.25954 16.676C6.38379 16.5887 6.52445 16.5274 6.67304 16.496L10.044 15.653"
                  stroke="#344F7A"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <Text fontSize={'13px'}>
                Last updated on{' '}
                {moment(visit.updated_at)
                  .tz(moment.tz.guess())
                  .format('MMM D, YYYY [at] h:mm A z')}
              </Text>
            </Flex>
            <LatestFromPhysician visit={visit} />
          </Flex>
          <Mutation
            mutation={GET_VISITS_TOKEN}
            onCompleted={(e) => {
              if (e && e.getAsyncVisitToken) {
                window.location = `${window._env_.REACT_APP_RX_VISITS_URL}/auth#token=${encodeURIComponent(e.getAsyncVisitToken)}&redirect=${visit.sku}`;
              }
            }}
          >
            {(generateToken, { loading }) => (
              <Button
                variant={'outline'}
                alignSelf={'center'}
                style={{ maxWidth: 'fit-content', fontSize: '14px', fontWeight: 400, paddingLeft: '16px', paddingRight: '16px', paddingTop: '8px', paddingBottom: '8px' }}
                disabled={!!loading}
                onClick={() => {
                  if (!!loading) return;
                  generateToken();
                }}
              >
                Finish intake
              </Button>
            )}
          </Mutation>
        </Flex>
      </FlexCard>
    </Box>
  );
};

const AsyncVisitsSentToPharmacy = ({ visit, products }) => {
  const product = products.find((x) => x.palomaSku === visit.sku.replace('_', '-').toUpperCase());

  return (
    <Box
      style={{
        borderRadius: '10px 10px 40px 40px',
        backgroundColor: '#E7F0FF',
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
      }}
    >
      <FlexCard
        style={{
          width: '100%',
          background: 'white',
          padding: '8px 20px 8px 8px',
          borderRadius: '10px',
          gap: 32,
          boxShadow: '5px 10px 50px 0 rgba(0, 0, 0, 0.07)',
          position: 'relative',
        }}
        alignItems={'flex-start'}
      >
        <Img src={(product || {}).imageUrl || PillsBottle} style={{ objectFit: 'cover', borderRadius: 12, height: 'stretch' }} alt="" />

        <Flex flex={1} flexDirection={'column'} justifyContent={'center'} style={{ padding: '16px 0 ' }}>
          <Text style={{ fontSize: 16, fontWeight: 600 }}>{visit.product_label}</Text>
          <Card
            mt={3}
            mb={3}
            p={'3px 12px'}
            style={{
              background: '#F8E8CF',
              maxWidth: 'fit-content',
              borderRadius: 20,
            }}
          >
            <Text fontSize={14} fontWeight={500} color={'#765126'}>
              {toTitleCase(visit.status || '')}
            </Text>
          </Card>
          <Flex style={{ gap: 8, opacity: 0.8 }} mb={'6px'} alignItems={'center'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M21 4.6875H3C2.85082 4.6875 2.70774 4.74676 2.60225 4.85225C2.49676 4.95774 2.4375 5.10082 2.4375 5.25V18C2.4375 18.3481 2.57578 18.6819 2.82192 18.9281C3.06806 19.1742 3.4019 19.3125 3.75 19.3125H20.25C20.5981 19.3125 20.9319 19.1742 21.1781 18.9281C21.4242 18.6819 21.5625 18.3481 21.5625 18V5.25C21.5625 5.10082 21.5032 4.95774 21.3977 4.85225C21.2923 4.74676 21.1492 4.6875 21 4.6875ZM12 12.7369L4.44562 5.8125H19.5544L12 12.7369ZM9.53156 12L3.5625 17.4713V6.52875L9.53156 12ZM10.3641 12.7631L11.625 13.9144C11.7287 14.0092 11.8641 14.0619 12.0047 14.0619C12.1452 14.0619 12.2807 14.0092 12.3844 13.9144L13.6406 12.7631L19.5544 18.1875H4.44656L10.3641 12.7631ZM14.4684 12L20.4375 6.52875V17.4713L14.4684 12Z"
                fill="#344F7A"
              />
            </svg>

            <Text fontSize={'13px'}>
              Submitted on{' '}
              {moment(visit.submitted_at)
                .tz(moment.tz.guess())
                .format('MMM D, YYYY [at] h:mm A z')}
            </Text>
          </Flex>
          <Flex style={{ gap: 8, opacity: 0.8 }} alignItems={'center'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M18.024 7.04299C16.8528 5.87629 15.3626 5.08233 13.741 4.76114C12.1194 4.43996 10.439 4.60592 8.91151 5.23811C7.38406 5.87031 6.0779 6.94045 5.1576 8.31371C4.23731 9.68696 3.74405 11.3019 3.73999 12.955"
                stroke="#344F7A"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
              />
              <path
                d="M17.3501 2.75L18.1821 6.122C18.2204 6.26895 18.2285 6.42214 18.2059 6.57231C18.1833 6.72248 18.1305 6.86652 18.0507 6.9957C17.9709 7.12488 17.8657 7.23654 17.7415 7.3239C17.6173 7.41127 17.4766 7.47254 17.3281 7.504L13.9561 8.347"
                stroke="#344F7A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5.97607 16.957C7.14717 18.1241 8.63753 18.9183 10.2593 19.2397C11.8811 19.5611 13.5617 19.3952 15.0894 18.763C16.617 18.1308 17.9233 17.0605 18.8437 15.687C19.764 14.3135 20.2572 12.6984 20.2611 11.045"
                stroke="#344F7A"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
              />
              <path
                d="M6.65004 21.25L5.81804 17.878C5.77988 17.7309 5.77191 17.5777 5.79461 17.4275C5.81731 17.2774 5.87021 17.1334 5.95012 17.0042C6.03003 16.875 6.13529 16.7634 6.25954 16.676C6.38379 16.5887 6.52445 16.5274 6.67304 16.496L10.044 15.653"
                stroke="#344F7A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <Text fontSize={'13px'}>
              Last updated on{' '}
              {moment(visit.updated_at)
                .tz(moment.tz.guess())
                .format('MMM D, YYYY [at] h:mm A z')}
            </Text>
          </Flex>
          {visit.prescription && (
            <Flex
              mt={3}
              mb={2}
              style={{
                borderLeft: '4px solid #e7e7e7',
                paddingLeft: '6px',
              }}
            >
              <Text fontSize={'13px'}>
                {visit.prescription.medication_label}
                &nbsp;·&nbsp;sent to {!visit.prescription.pharmacy ? 'your pharmacy' : `${visit.prescription.pharmacy.name}, ${visit.prescription.pharmacy.city}`}
                &nbsp;·&nbsp;
                {visit.prescription.sent_at
                  ? moment(visit.prescription.sent_at)
                      .tz(moment.tz.guess())
                      .format('MMM D, YYYY')
                  : ''}
              </Text>
            </Flex>
          )}
          {!!visit.appointment_id && <LatestFromPhysician visit={visit} buttonCaption={'Reply to care team'} />}
        </Flex>
      </FlexCard>
    </Box>
  );
};

const AsyncVisitsPending = ({ visit, products }) => {
  const product = products.find((x) => x.palomaSku === visit.sku.replace('_', '-').toUpperCase());

  return (
    <Box
      style={{
        borderRadius: '10px 10px 40px 40px',
        backgroundColor: '#E7F0FF',
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
      }}
    >
      <FlexCard
        style={{
          width: '100%',
          background: 'white',
          padding: '8px 20px 8px 8px',
          borderRadius: '10px',
          gap: 32,
          boxShadow: '5px 10px 50px 0 rgba(0, 0, 0, 0.07)',
          position: 'relative',
        }}
        alignItems={'flex-start'}
      >
        <Img src={(product || {}).imageUrl || PillsBottle} style={{ objectFit: 'cover', borderRadius: 12, height: 'stretch' }} alt="" />

        <Flex flex={1} flexDirection={'column'} justifyContent={'center'} style={{ padding: '16px 0 ' }}>
          <Text style={{ fontSize: 16, fontWeight: 600 }}>{visit.product_label}</Text>
          <Card
            mt={3}
            mb={3}
            p={'3px 12px'}
            style={{
              background: '#F8E8CF',
              maxWidth: 'fit-content',
              borderRadius: 20,
            }}
          >
            <Text fontSize={14} fontWeight={500} color={'#765126'}>
              {toTitleCase(visit.status || '')}
            </Text>
          </Card>
          <Flex style={{ gap: 8, opacity: 0.8 }} mb={'6px'} alignItems={'center'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M21 4.6875H3C2.85082 4.6875 2.70774 4.74676 2.60225 4.85225C2.49676 4.95774 2.4375 5.10082 2.4375 5.25V18C2.4375 18.3481 2.57578 18.6819 2.82192 18.9281C3.06806 19.1742 3.4019 19.3125 3.75 19.3125H20.25C20.5981 19.3125 20.9319 19.1742 21.1781 18.9281C21.4242 18.6819 21.5625 18.3481 21.5625 18V5.25C21.5625 5.10082 21.5032 4.95774 21.3977 4.85225C21.2923 4.74676 21.1492 4.6875 21 4.6875ZM12 12.7369L4.44562 5.8125H19.5544L12 12.7369ZM9.53156 12L3.5625 17.4713V6.52875L9.53156 12ZM10.3641 12.7631L11.625 13.9144C11.7287 14.0092 11.8641 14.0619 12.0047 14.0619C12.1452 14.0619 12.2807 14.0092 12.3844 13.9144L13.6406 12.7631L19.5544 18.1875H4.44656L10.3641 12.7631ZM14.4684 12L20.4375 6.52875V17.4713L14.4684 12Z"
                fill="#344F7A"
              />
            </svg>

            <Text fontSize={'13px'}>
              Submitted on{' '}
              {moment(visit.submitted_at)
                .tz(moment.tz.guess())
                .format('MMM D, YYYY [at] h:mm A z')}
            </Text>
          </Flex>
          <Flex style={{ gap: 8, opacity: 0.8 }} alignItems={'center'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M18.024 7.04299C16.8528 5.87629 15.3626 5.08233 13.741 4.76114C12.1194 4.43996 10.439 4.60592 8.91151 5.23811C7.38406 5.87031 6.0779 6.94045 5.1576 8.31371C4.23731 9.68696 3.74405 11.3019 3.73999 12.955"
                stroke="#344F7A"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
              />
              <path
                d="M17.3501 2.75L18.1821 6.122C18.2204 6.26895 18.2285 6.42214 18.2059 6.57231C18.1833 6.72248 18.1305 6.86652 18.0507 6.9957C17.9709 7.12488 17.8657 7.23654 17.7415 7.3239C17.6173 7.41127 17.4766 7.47254 17.3281 7.504L13.9561 8.347"
                stroke="#344F7A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5.97607 16.957C7.14717 18.1241 8.63753 18.9183 10.2593 19.2397C11.8811 19.5611 13.5617 19.3952 15.0894 18.763C16.617 18.1308 17.9233 17.0605 18.8437 15.687C19.764 14.3135 20.2572 12.6984 20.2611 11.045"
                stroke="#344F7A"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
              />
              <path
                d="M6.65004 21.25L5.81804 17.878C5.77988 17.7309 5.77191 17.5777 5.79461 17.4275C5.81731 17.2774 5.87021 17.1334 5.95012 17.0042C6.03003 16.875 6.13529 16.7634 6.25954 16.676C6.38379 16.5887 6.52445 16.5274 6.67304 16.496L10.044 15.653"
                stroke="#344F7A"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <Text fontSize={'13px'}>
              Last updated on{' '}
              {moment(visit.updated_at)
                .tz(moment.tz.guess())
                .format('MMM D, YYYY [at] h:mm A z')}
            </Text>
          </Flex>
          {!!visit.appointment_id && <LatestFromPhysician visit={visit} buttonCaption={'Reply to care team'} />}
        </Flex>
      </FlexCard>
    </Box>
  );
};

const AsyncVisitsDeclinedCard = ({ visit, products }) => {
  const product = products.find((x) => x.palomaSku === visit.sku.replace('_', '-').toUpperCase());

  return (
    <Box
      style={{
        borderRadius: '10px 10px 40px 40px',
        backgroundColor: '#E7F0FF',
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
      }}
    >
      <FlexCard
        style={{
          width: '100%',
          background: 'white',
          padding: '8px',
          borderRadius: '10px',
          gap: 32,
          boxShadow: '5px 10px 50px 0 rgba(0, 0, 0, 0.07)',
          position: 'relative',
        }}
        alignItems={'flex-start'}
      >
        <Img src={(product || {}).imageUrl || PillsBottle} style={{ objectFit: 'cover', borderRadius: 12, height: 'stretch' }} alt="" />
        <Flex flex={1} flexDirection={'column'} justifyContent={'center'} style={{ padding: '16px 0 ' }}>
          <Text style={{ fontSize: 16, fontWeight: 600 }}>{visit.product_label}</Text>
          <Card
            mt={3}
            mb={3}
            p={'3px 12px'}
            style={{
              background: '#ECECED',
              maxWidth: 'fit-content',
              borderRadius: 20,
            }}
          >
            <Text fontSize={14} fontWeight={500} color={'#4D4E4F'}>
              Declined
            </Text>
          </Card>
          <Flex style={{ gap: 8, opacity: 0.8 }} mb={'6px'} alignItems={'center'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M21 4.6875H3C2.85082 4.6875 2.70774 4.74676 2.60225 4.85225C2.49676 4.95774 2.4375 5.10082 2.4375 5.25V18C2.4375 18.3481 2.57578 18.6819 2.82192 18.9281C3.06806 19.1742 3.4019 19.3125 3.75 19.3125H20.25C20.5981 19.3125 20.9319 19.1742 21.1781 18.9281C21.4242 18.6819 21.5625 18.3481 21.5625 18V5.25C21.5625 5.10082 21.5032 4.95774 21.3977 4.85225C21.2923 4.74676 21.1492 4.6875 21 4.6875ZM12 12.7369L4.44562 5.8125H19.5544L12 12.7369ZM9.53156 12L3.5625 17.4713V6.52875L9.53156 12ZM10.3641 12.7631L11.625 13.9144C11.7287 14.0092 11.8641 14.0619 12.0047 14.0619C12.1452 14.0619 12.2807 14.0092 12.3844 13.9144L13.6406 12.7631L19.5544 18.1875H4.44656L10.3641 12.7631ZM14.4684 12L20.4375 6.52875V17.4713L14.4684 12Z"
                fill="#344F7A"
              />
            </svg>

            <Text fontSize={'13px'}>
              Submitted on{' '}
              {moment(visit.submitted_at)
                .tz(moment.tz.guess())
                .format('MMM D, YYYY [at] h:mm A z')}
            </Text>
          </Flex>
          <Flex style={{ gap: 8, opacity: 0.8 }} alignItems={'center'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.5 12C22.5 17.805 17.805 22.5 12 22.5C6.195 22.5 1.5 17.805 1.5 12C1.5 6.195 6.195 1.5 12 1.5C17.805 1.5 22.5 6.195 22.5 12ZM21 12C21 16.965 16.965 21 12 21C9.78 21 7.755 20.199 6.195 18.87L18.885 6.18C20.2583 7.80272 21.0129 9.85917 21.015 11.985L21 12ZM5.1 17.805L17.79 5.115C16.1673 3.7417 14.1108 2.98714 11.985 2.985C7.02 2.985 2.985 7.02 2.985 11.985C2.985 14.205 3.786 16.23 5.115 17.79L5.1 17.805Z"
                fill="#344F7A"
              />
            </svg>

            <Text fontSize={'13px'}>
              Declined on{' '}
              {moment(visit.updated_at)
                .tz(moment.tz.guess())
                .format('MMM D, YYYY [at] h:mm A z')}
            </Text>
          </Flex>

          <LatestFromPhysician visit={visit} />
        </Flex>
        {!!visit.reapply_available_at && (
          <Flex style={{ padding: '0 12px', borderLeft: '1px solid #d3d3d3', gap: '12px' }} alignSelf={'center'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M19.5 3.75H4.5C3.25736 3.75 2.25 4.75736 2.25 6V19.5C2.25 20.7426 3.25736 21.75 4.5 21.75H19.5C20.7426 21.75 21.75 20.7426 21.75 19.5V6C21.75 4.75736 20.7426 3.75 19.5 3.75Z"
                stroke="#344F7A"
                strokeLinejoin="round"
              />
              <path d="M13.875 12C14.4963 12 15 11.4963 15 10.875C15 10.2537 14.4963 9.75 13.875 9.75C13.2537 9.75 12.75 10.2537 12.75 10.875C12.75 11.4963 13.2537 12 13.875 12Z" fill="#344F7A" />
              <path
                d="M17.625 12C18.2463 12 18.75 11.4963 18.75 10.875C18.75 10.2537 18.2463 9.75 17.625 9.75C17.0037 9.75 16.5 10.2537 16.5 10.875C16.5 11.4963 17.0037 12 17.625 12Z"
                fill="#344F7A"
              />
              <path
                d="M13.875 15.75C14.4963 15.75 15 15.2463 15 14.625C15 14.0037 14.4963 13.5 13.875 13.5C13.2537 13.5 12.75 14.0037 12.75 14.625C12.75 15.2463 13.2537 15.75 13.875 15.75Z"
                fill="#344F7A"
              />
              <path
                d="M17.625 15.75C18.2463 15.75 18.75 15.2463 18.75 14.625C18.75 14.0037 18.2463 13.5 17.625 13.5C17.0037 13.5 16.5 14.0037 16.5 14.625C16.5 15.2463 17.0037 15.75 17.625 15.75Z"
                fill="#344F7A"
              />
              <path
                d="M6.375 15.75C6.99632 15.75 7.5 15.2463 7.5 14.625C7.5 14.0037 6.99632 13.5 6.375 13.5C5.75368 13.5 5.25 14.0037 5.25 14.625C5.25 15.2463 5.75368 15.75 6.375 15.75Z"
                fill="#344F7A"
              />
              <path
                d="M10.125 15.75C10.7463 15.75 11.25 15.2463 11.25 14.625C11.25 14.0037 10.7463 13.5 10.125 13.5C9.50368 13.5 9 14.0037 9 14.625C9 15.2463 9.50368 15.75 10.125 15.75Z"
                fill="#344F7A"
              />
              <path
                d="M6.375 19.5C6.99632 19.5 7.5 18.9963 7.5 18.375C7.5 17.7537 6.99632 17.25 6.375 17.25C5.75368 17.25 5.25 17.7537 5.25 18.375C5.25 18.9963 5.75368 19.5 6.375 19.5Z"
                fill="#344F7A"
              />
              <path
                d="M10.125 19.5C10.7463 19.5 11.25 18.9963 11.25 18.375C11.25 17.7537 10.7463 17.25 10.125 17.25C9.50368 17.25 9 17.7537 9 18.375C9 18.9963 9.50368 19.5 10.125 19.5Z"
                fill="#344F7A"
              />
              <path
                d="M13.875 19.5C14.4963 19.5 15 18.9963 15 18.375C15 17.7537 14.4963 17.25 13.875 17.25C13.2537 17.25 12.75 17.7537 12.75 18.375C12.75 18.9963 13.2537 19.5 13.875 19.5Z"
                fill="#344F7A"
              />
              <path d="M6 2.25V3.75M18 2.25V3.75" stroke="#344F7A" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M21.75 7.5H2.25" stroke="#344F7A" strokeLinejoin="round" />
            </svg>

            <Flex flexDirection={'column'} style={{ gap: 6 }}>
              <Text fontSize={13} fontWeight={500} color={'#616161'}>
                You can reapply on
              </Text>
              <Text style={{ fontSize: 16, fontWeight: 600 }}>{moment(visit.reapply_available_at).format('MMM D, YYYY')}</Text>
              <Text fontSize={13} fontWeight={500} color={'#616161'}>
                We'll remind you when
                <br />
                you can reapply.
              </Text>
            </Flex>
          </Flex>
        )}
      </FlexCard>
    </Box>
  );
};

const AsyncVisitsPendingInProgress = ({ visits, products }) => {
  if (!visits) return null;
  if ((!visits.inProgress || visits.inProgress.length < 1) && (!visits.submitted || visits.submitted.length < 1) && (!visits.sentToPharmacy || visits.sentToPharmacy.length<1)) return null;

  return (
    <Flex style={{ flexDirection: 'column', gap: 16 }}>
      <Flex style={{ gap: 16 }}>
        <Text fontSize={18} fontWeight={600}>
          Open Requests
        </Text>

        <Card
          p={'3px 12px'}
          style={{
            background: '#F3E0BD',
            maxWidth: 'fit-content',
            borderRadius: 20,
          }}
        >
          <Text fontSize={14} fontWeight={500} color={'#6A4A19'}>
            {(visits.inProgress || []).length + (visits.submitted || []).length + (visits.sentToPharmacy || []).length}
          </Text>
        </Card>
      </Flex>
      <Text mb={3}>These visits were submitted by you and are being reviewed by your care team:</Text>
      {(visits.inProgress || []).map((x) => (
        <AsyncVisitsInProgress key={x.id} visit={x} products={products} />
      ))}
      {(visits.sentToPharmacy || []).map((x) => (
        <AsyncVisitsSentToPharmacy key={x.id} visit={x} products={products} />
      ))}
      {(visits.submitted || []).map((x) => (
        <AsyncVisitsPending key={x.id} visit={x} products={products} />
      ))}
    </Flex>
  );
};

const AsyncVisitsDeclined = ({ visits, products }) => {
  if (!visits) return null;
  if (!visits.declined || visits.declined.length < 1) return null;

  return (
    <Flex style={{ flexDirection: 'column', gap: 16 }}>
      <Flex style={{ gap: 16 }}>
        <Text fontSize={18} fontWeight={600}>
          Declined Requests
        </Text>

        <Card
          p={'3px 12px'}
          style={{
            background: '#F3E0BD',
            maxWidth: 'fit-content',
            borderRadius: 20,
          }}
        >
          <Text fontSize={14} fontWeight={500} color={'#6A4A19'}>
            {(visits.declined || []).length}
          </Text>
        </Card>
      </Flex>
      <Text mb={3}>These visits were reviewed and could not be approved at this time:</Text>
      {(visits.declined || []).map((x) => (
        <AsyncVisitsDeclinedCard key={x.id} visit={x} products={products} />
      ))}
    </Flex>
  );
};

const AsyncVisits = ({ visits, products }) => {
  if (!visits) return null;
  if ((!visits.inProgress || visits.inProgress.length < 1) && (!visits.submitted || visits.submitted.length < 1) && (!visits.declined || visits.declined.length < 1) && (!visits.sentToPharmacy || visits.sentToPharmacy.length<1)) return null;

  return (
    <Flex flexDirection={'column'} style={{ gap: 32 }} mb={4}>
      <AsyncVisitsPendingInProgress visits={visits} products={products} />
      <AsyncVisitsDeclined visits={visits} products={products} />
    </Flex>
  );
};

const MyRx = ({ session, match, history }) => {
  if (!session || !session.eligibility || !session.eligibility.canBookAsync) {
    history.replace('/');
    return null;
  }

  const selected = !match.isExact ? 'selected' : null;

  return (
    <Query query={GET_PALOMARX_PRODUCTS}>
      {({ loading: loadingProducts, data: dataProducts, error }) => {
        if (loadingProducts) return <LoadingScreen />;
        return (
          <Query query={ASYNC_VISITS}>
            {({ loading: loadingAsyncVisits, data: dataAsyncVisits }) => {
              if (loadingAsyncVisits) return <LoadingScreen />;

              return (
                <Query query={GET_PALOMA_RX} fetchPolicy="network-only">
                  {({ data, loading, error }) => {
                    if (loading) {
                      return <LoadingScreen />;
                    }

                    if (!!error) {
                      return (
                        <Container alignItems={'center'} justifyContent={'center'} style={{ height: '100%', display: 'flex' }}>
                          <Flex
                            alignItems={'center'}
                            justifyContent={'center'}
                            style={{
                              maxWidth: 'min(80vw, 500px)',
                              margin: '0 auto',
                              flexDirection: 'column',
                              paddingBottom: '60px',
                            }}
                          >
                            <img src={Estriol} />
                            <Text textAlign={'center'} fontSize={'30px'} fontWeight={600} mt={4} mb={3}>
                              Oooops...
                            </Text>

                            <Text textAlign={'center'} mb={4}>
                              An error occured
                            </Text>

                            <Button variant={'primary'} onClick={() => history.push('/rx-products')}>
                              Browse Custom Rx Products
                            </Button>
                          </Flex>
                        </Container>
                      );
                    }

                    if (
                      (!dataAsyncVisits ||
                        !dataAsyncVisits.getPalomaAsyncVisits ||
                        ((!dataAsyncVisits.getPalomaAsyncVisits.inProgress || dataAsyncVisits.getPalomaAsyncVisits.inProgress.length < 1) &&
                          (!dataAsyncVisits.getPalomaAsyncVisits.submitted || dataAsyncVisits.getPalomaAsyncVisits.submitted.length < 1) &&
                          (!dataAsyncVisits.getPalomaAsyncVisits.sentToPharmacy || dataAsyncVisits.getPalomaAsyncVisits.sentToPharmacy.length < 1) &&
                          (!dataAsyncVisits.getPalomaAsyncVisits.declined || dataAsyncVisits.getPalomaAsyncVisits.declined.length < 1))) &&
                      (!data || !data.getPalomaRxs || data.getPalomaRxs.length < 1 || data.getPalomaRxs.filter((x) => !!x && !!x.medication).length < 1)
                    ) {
                      return (
                        <Container alignItems={'center'} justifyContent={'center'} style={{ height: '100%', display: 'flex' }}>
                          <Flex
                            alignItems={'center'}
                            justifyContent={'center'}
                            style={{
                              maxWidth: 'min(80vw, 500px)',
                              margin: '0 auto',
                              flexDirection: 'column',
                              paddingBottom: '60px',
                            }}
                          >
                            <img src={Estriol} />
                            <Text textAlign={'center'} fontSize={'30px'} fontWeight={600} mt={4} mb={3}>
                              No prescriptions yet
                            </Text>

                            <Text textAlign={'center'} mb={4}>
                              You don't have any active Custom Rx prescriptions at the moment.
                              <br />
                              <br />
                              Treatments fulfilled by our partner pharmacies will appear here once prescribed by your Paloma clinician.
                            </Text>

                            <Button variant={'primary'} onClick={() => history.push('/rx-products')}>
                              Browse Custom Rx Products
                            </Button>
                          </Flex>
                        </Container>
                      );
                    }
                    return (
                      <>
                        <Container>
                          <InnerContainer>
                            <Heading mb={4}>My Rx</Heading>
                            {!!dataAsyncVisits &&
                              dataAsyncVisits.getPalomaAsyncVisits && (
                                <AsyncVisits visits={dataAsyncVisits.getPalomaAsyncVisits} products={((dataProducts || {}).getPalomaRxCatalog || {}).products || []} />
                              )}
                            <Flex style={{ gap: 16, marginBottom: '16px' }}>
                              <Text fontSize={18} fontWeight={600} id="rx_active">
                                Active prescriptions
                              </Text>

                              <Card
                                p={'3px 12px'}
                                style={{
                                  background: '#F3E0BD',
                                  maxWidth: 'fit-content',
                                  borderRadius: 20,
                                }}
                              >
                                <Text fontSize={14} fontWeight={500} color={'#6A4A19'}>
                                  {(data.getPalomaRxs.filter((x) => !!x && !!x.medication) || []).length}
                                </Text>
                              </Card>
                            </Flex>
                            <Text mb={3}>Here are your active prescriptions being fulfilled by our partner pharmacies:</Text>
                            <Flex style={{ flexDirection: 'column', gap: 32 }}>
                              {data.getPalomaRxs.filter((x) => !!x && !!x.medication && x.status !== 'cancelled').map((x) => (
                                <PrescriptionDisplay prescription={x} key={x.id} history={history} communicate />
                              ))}
                            </Flex>
                          </InnerContainer>
                        </Container>

                        <DetailContainer
                          flex={1}
                          justifyContent="center"
                          className={selected}
                          id="testContainer"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <Inner
                            flex={1}
                            flexDirection="column"
                            pt={[0, 0, 3]}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          >
                            <Route
                              path="/my-rx/communicator/:id"
                              exact
                              component={(props) => {
                                return (
                                  <>
                                    <div>
                                      <BackButtonDesktop>
                                        <svg
                                          onClick={() => history.goBack()}
                                          width="40"
                                          height="40"
                                          viewBox="0 0 40 40"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                          style={{ transform: 'rotate(180deg)', cursor: 'pointer' }}
                                        >
                                          <path d="M21.3337 8.33335L31.3337 20L21.3337 31.6667" stroke="#4E658A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                          <path d="M11.6667 8.33335L21.6667 20L11.6667 31.6667" stroke="#4E658A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                      </BackButtonDesktop>
                                    </div>
                                    <DetailNavigation>
                                      <BackButton onClick={() => history.push('/my-rx')}>{`<  Your Rx`}</BackButton>
                                    </DetailNavigation>
                                    <Communicator isShowOnlyDesktop isAsync appointmentId={props.match.params.id} />
                                  </>
                                );
                              }}
                            />
                            <Route path="/my-rx/:id" exact component={(props) => <PalomaRxDetails list={data.getPalomaRxs} />} />
                          </Inner>
                        </DetailContainer>
                      </>
                    );
                  }}
                </Query>
              );
            }}
          </Query>
        );
      }}
    </Query>
  );
};

export default compose(
  withSession,
  withRouter,
)(MyRx);
